import { 
  FETCH_CORPS_MEMBER, 
  LOGIN_USER,
  CHANGE_PASSWORD,
  REGISTER_LGI_USER,
  FETCH_ALL_LGI_USERS,
  RELOCATE_LGI,
  AUTH_CM_GUID,
  ACTIVATE_LGI,
  DEACTIVATE_LGI,
  RESET_PASSWORD,
} from "../ActionTypes";

import { 
  fetchCorpsMemberSuccess, 
  userLoginSuccess,
  userLoginFailure,
  changePasswordSuccess,
  changePasswordFailure,
  fetchCorpsMemberFailure,
  registerLGIUserSuccess,
  registerLGIUserFailure,
  fetchAllLGIUsersSuccess,
  fetchAllLGIUsersFailure,
  relocateLGISuccess,
  relocateLGIFailure,
  authCmGuidFailure,
  authCmGuidSuccess,
  engageLGISuccess,
  disengageLGISuccess,
  engageLGIFailure,
  disengageLGIFailure,
  resetPasswordSuccess,
  resetPasswordFailure,
} from "../Actions";

import {
  getCorpsMember, 
  Login,
  changePasswordApi,
  RegisterLGIApi,
  fetchAllLGIUsersApi,
  relocateLGIApi,
  authCmByGuidApi,
  engageLGIApi,
  disengageLGIApi,
  resetPasswordApi
} from "../Api";

import newSGF from "../Utils/newSGF";
import { all, call, fork, takeEvery } from "redux-saga/effects";


// Requests
const userSignInRequest = function* ({ payload }) {
  yield call(newSGF, userLoginSuccess, userLoginFailure, Login, payload);
};

const authCmByGuidRequest = function* ({payload}) {
  yield call(newSGF, authCmGuidSuccess, authCmGuidFailure, authCmByGuidApi, payload)
}

const getCorpsMemberRequest = function* ({ payload }) {
  yield call(newSGF, fetchCorpsMemberSuccess, fetchCorpsMemberFailure, getCorpsMember, payload);
};

const changePasswordRequest = function* ({ payload }) {
  yield call(newSGF, changePasswordSuccess, changePasswordFailure, changePasswordApi, payload)
}

const registerLGIRequest = function* ({ payload }) {
  yield call(newSGF, registerLGIUserSuccess, registerLGIUserFailure, RegisterLGIApi, payload)
}

const fetchAllLGIUsersRequest = function* ({ payload }) {
  yield call(newSGF, fetchAllLGIUsersSuccess, fetchAllLGIUsersFailure, fetchAllLGIUsersApi, payload)
}

const relocateLGIRequest = function* ({ payload }) {
  yield call(newSGF, relocateLGISuccess, relocateLGIFailure, relocateLGIApi, payload)
}

const activateLGIRequest = function* ({ payload }) {
  yield call(newSGF, engageLGISuccess, engageLGIFailure, engageLGIApi, payload)
}

const deactivateLGIRequest = function* ({ payload }) {
  yield call(newSGF, disengageLGISuccess, disengageLGIFailure, disengageLGIApi, payload)
}

const resetPasswordLGIRequest = function* ({ payload }) {
  yield call(newSGF, resetPasswordSuccess, resetPasswordFailure, resetPasswordApi, payload)
}

// Watchers
export const userSignin = function* () {
  yield takeEvery(LOGIN_USER, userSignInRequest);
};

export const authCmByGuidWatcher = function* () {
  yield takeEvery(AUTH_CM_GUID, authCmByGuidRequest)
}

export const corpsMember = function* () {
  yield takeEvery(FETCH_CORPS_MEMBER, getCorpsMemberRequest);
};

export const changePasswordWatcher = function* () {
  yield takeEvery(CHANGE_PASSWORD, changePasswordRequest);
}

export const registerLGIWatcher = function* () {
  yield takeEvery(REGISTER_LGI_USER, registerLGIRequest);
}

export const fetchAllLGIs = function* () {
  yield takeEvery(FETCH_ALL_LGI_USERS, fetchAllLGIUsersRequest);
}

export const relocateLGI = function* () {
  yield takeEvery(RELOCATE_LGI, relocateLGIRequest);
}

export const activateLGI = function* () {
  yield takeEvery(ACTIVATE_LGI, activateLGIRequest);
}

export const deactivateLGI = function* () {
  yield takeEvery(DEACTIVATE_LGI, deactivateLGIRequest);
}
export const resetPasswordLGI = function* () {
  yield takeEvery(RESET_PASSWORD, resetPasswordLGIRequest);
}

export default function* rootSaga() {
  yield all([
    fork(userSignin),
    fork(corpsMember),
    fork(changePasswordWatcher),
    fork(registerLGIWatcher),
    fork(fetchAllLGIs),
    fork(relocateLGI),
    fork(authCmByGuidWatcher),
    fork(activateLGI),
    fork(deactivateLGI),
    fork(resetPasswordLGI),
  ]);
}
